import { createContext, useContext } from "react";

export const DiscussIdContext = createContext<{
  discussId: string;
  slug: string;
}>({
  discussId: "",
  slug: "",
});

export const useDiscussIdContext = () => {
  const context = useContext(DiscussIdContext);
  if (!context) {
    throw new Error(
      "useDiscussIdContext must be used within a DiscussIdContext"
    );
  }
  return context;
};
